export default "__VITE_ASSET__CPUkcPaw__"